var _rect, _g, _rect2, _path, _path2, _path3, _path4, _path5, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 268,
    viewBox: "0 0 245 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.0361,
    y: 37.0483,
    width: 139.99,
    height: 191.284,
    rx: 16.3981,
    transform: "rotate(2.95434 82.0361 37.0483)",
    fill: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16300_100923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.751 65.5451C157.978 58.1838 151.383 52.8435 144.022 53.6172L72.9221 61.0901L26.3118 118.955L39.0148 239.816C39.7885 247.177 46.3832 252.517 53.7445 251.743L163.632 240.194C170.993 239.42 176.333 232.825 175.56 225.464L158.751 65.5451Z",
    fill: "#F6F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2764 118.685L65.064 114.608C72.4252 113.835 77.7655 107.24 76.9918 99.8786L72.9151 61.0911L26.2764 118.685Z",
    fill: "#D9D9D9"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.71,
    y: 126.416,
    width: 82.1311,
    height: 82.1311,
    rx: 41.0656,
    transform: "rotate(-5.92984 53.71 126.416)",
    fill: "#E0E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.424 179.299C109.447 178.362 116.002 170.287 115.065 161.264C114.128 152.24 106.053 145.685 97.0297 146.622C88.0063 147.56 81.4512 155.634 82.3884 164.658C83.3256 173.681 91.4003 180.236 100.424 179.299ZM106.023 159.534C106.738 158.653 106.604 157.36 105.723 156.646C104.843 155.931 103.55 156.065 102.835 156.946L96.8087 164.369L93.894 162.003C93.0136 161.288 91.7205 161.423 91.0057 162.303C90.291 163.183 90.4253 164.476 91.3057 165.191L95.8146 168.851C96.695 169.566 97.9881 169.432 98.7028 168.551L106.023 159.534Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2061 84.2495L2.02465 92.4309",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02637 84.2515L10.2078 92.4329",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.823 2.0249L196.355 9.49304",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.353 2.02686L203.821 9.49499",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 236.368,
    cy: 247.513,
    r: 5.78512,
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16300_100923",
    x: 12.8742,
    y: 42.8207,
    width: 176.162,
    height: 225.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.68044
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7011
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16300_100923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16300_100923",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedInterview);
export default __webpack_public_path__ + "static/media/completedInterview.782a1ea0b1311ea3ddc84eb504b6e61a.svg";
export { ForwardRef as ReactComponent };